// OWNER: LG-ADMIN. CONTRACT: export name and props fixed. Routed by app.tsx at /lead-search (nav "Lead search").
// SPEC §19 (2026-10-01): setters see New search, Searches and Results (their own searches); every run by anyone but the
// spend owner goes to PJ for approval first (Approvals page).
// Deep links: /lead-search/<tab>[/<searchId>] arrive as params.rest (e.g. 'results/12'); tabs in ../leadgen/tabs.tsx.
// LEADGEN-SPEC §10: Niches, New search, Searches, Results, Checks, Spend.
import { navigate } from '../app';
import { Tabs } from '../admin/ui';
import { ChecksTab, NewSearchTab, NichesTab, ResultsTab, SearchesTab, SpendTab } from '../leadgen/tabs';
import { LEAD_SEARCH_TABS, deepLinkPath, parseDeepLink, type LeadSearchTab } from '../leadgen/logic';
import { useMe } from '../me';
import { useApprovals } from '../approvals';

const SETTER_TABS: LeadSearchTab[] = ['new', 'searches', 'results'];

export function LeadSearch(props: { params: Record<string, string> }) {
  const me = useMe();
  const appr = useApprovals();
  const parsed = parseDeepLink(props.params.rest);
  const allowed = me.role === 'admin' ? LEAD_SEARCH_TABS : LEAD_SEARCH_TABS.filter((t) => SETTER_TABS.includes(t.key));
  const tab: LeadSearchTab = allowed.some((t) => t.key === parsed.tab) ? parsed.tab : 'searches';
  const searchId = parsed.searchId;
  const go = (t: LeadSearchTab, id?: number | null) => navigate(deepLinkPath(t, id ?? null));
  const owner = appr?.ownerName ?? 'PJ';
  return (
    <div class="adm-page">
      <div class="adm-head">
        <div>
          <h1>Lead search</h1>
          <div class="adm-sub">Find every business in a niche and a place, drop the ones we can't or shouldn't call, research and score the rest, then import the good ones with a source on every row.</div>
          {appr && !appr.isOwner ? <div class="adm-sub" style="margin-top:6px;color:var(--blue-ink)">Estimates are free. Every run goes to {owner} for approval first; nothing is spent until {owner.split(' ')[0]} approves it.</div> : null}
        </div>
      </div>
      <Tabs tabs={allowed.map((t) => ({ key: t.key, label: t.label, badge: t.key === 'results' && searchId ? `#${searchId}` : null }))}
        active={tab} onChange={(t) => go(t, t === 'results' ? searchId : null)} />
      {tab === 'niches' ? <NichesTab /> : null}
      {tab === 'new' ? <NewSearchTab onCreated={() => go('searches')} /> : null}
      {tab === 'searches' ? <SearchesTab onOpenResults={(id) => go('results', id)} /> : null}
      {tab === 'results' ? <ResultsTab searchId={searchId} /> : null}
      {tab === 'checks' ? <ChecksTab /> : null}
      {tab === 'spend' ? <SpendTab /> : null}
    </div>
  );
}
